const CART = {
  goal: 6000, // $60 
  state: { items: [], item_count: 0, items_subtotal_price: 0 },
  _lastRecKey: null,

  fmt(cents) { return `$${(cents / 100).toFixed(2)}`; },
  _toInt(x) { return (typeof x === 'number' ? x : parseInt(x, 10) || 0); },

  open() {
    const root = document.getElementById('oasis-cart');
    if (!root) return;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-open');
    document.querySelectorAll('[data-cart-open]').forEach(a => a.setAttribute('aria-expanded', 'true'));
  },

  close() {
    const root = document.getElementById('oasis-cart');
    if (!root) return;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-open');
    document.querySelectorAll('[data-cart-open]').forEach(a => a.setAttribute('aria-expanded', 'false'));
  },

  async fetch() {
    const res = await fetch('/cart.js');
    this.state = await res.json();
    this.render();
  },

  async add(formOrObj) {
    let body, headers = {};
    if (formOrObj instanceof FormData) {
      body = formOrObj;
    } else {
      body = new URLSearchParams(formOrObj).toString();
      headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
    }
    await fetch('/cart/add.js', { method: 'POST', headers, body });
    await this.fetch();
    this.open();
  },

  async change(line, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    await this.fetch();
  },

  async render() {
    const s = this.state;

    document.querySelectorAll('[data-cart-count]').forEach(n => (n.textContent = s.item_count));

    const fsbText = document.querySelector('[data-fsb-text]');
    const fsbProg = document.querySelector('[data-fsb-progress]');
    if (fsbText && fsbProg) {
      const left = Math.max(this.goal - s.items_subtotal_price, 0);
      const progress = Math.min((s.items_subtotal_price / this.goal) * 100, 100);
      fsbText.textContent = left > 0 ? `Spend ${this.fmt(left)} for Free Shipping.` : `You’ve got Free Shipping!`;
      fsbProg.style.width = `${progress}%`;
    }

    const emptyEl = document.querySelector('[data-empty]');
    const filledEl = document.querySelector('[data-filled]');
    if (emptyEl && filledEl) {
      if (s.item_count === 0) {
        emptyEl.hidden = false;
        filledEl.hidden = true;
      } else {
        emptyEl.hidden = true;
        filledEl.hidden = false;
      }
    }

    const list = document.querySelector('[data-line-items]');
    if (list) {
      list.innerHTML = '';
      (s.items || []).forEach((it, i) => {
        const qty = Math.max(it.quantity || 1, 1);

        const unitFinal = this._toInt(it.final_price) ||
                          Math.round(this._toInt(it.final_line_price || it.line_price || 0) / qty);

        const unitOrigExplicit = this._toInt(it.original_price);
        const unitOrigFromLine = Math.round(this._toInt(it.original_line_price || 0) / qty);
        const unitBasePrice    = this._toInt(it.price);

        const unitOrig = unitOrigExplicit || unitOrigFromLine || unitBasePrice || unitFinal;
        const unitBase = unitBasePrice || unitOrig || unitFinal;

        const isSub = !!(it.selling_plan_allocation && it.selling_plan_allocation.selling_plan);

        const li = document.createElement('li');
        li.className = 'oasis-item';
        li.innerHTML = `
          <img class="oasis-item__img" src="${it.image || ''}" alt="">
          <div class="oasis-item__meta">
            <div class="oasis-item__title">
              ${it.product_title || ''}${it.properties && it.properties['THC'] ? `, ${it.properties['THC']}` : ''}
            </div>
            ${(it.variant_title && it.variant_title.toLowerCase() !== 'default title') 
              ? `<div class="oasis-item__variant">Size: ${it.variant_title}</div>` 
              : ''}
            <div class="oasis-item__purchase">
              ${isSub ? 'Delivered every month' : 'One-time purchase'}
            </div>
            <div class="oasis-item__qty">
              <button data-qty-dec aria-label="Decrease">−</button>
              <span>${it.quantity}</span>
              <button data-qty-inc aria-label="Increase">+</button>
            </div>
          </div>

          <div class="oasis-item__prices">
            <div class="oasis-item__price-row">
              <div class="oasis-item__price" data-price="${it.key}"></div>
              <div class="oasis-item__compare" data-compare-price="${it.key}" hidden></div>
            </div>
            <button class="oasis-item__remove" data-remove aria-label="Remove item">
              <img src="https://cdn.shopify.com/s/files/1/0707/1993/0608/files/delete_FILL0_wght200_GRAD0_opsz24_1.svg?v=1754954458"
                   alt="Remove item" width="24" height="24">
            </button>
          </div>
        `;

        li.querySelector('[data-qty-dec]').addEventListener('click', () =>
          this.change(i + 1, Math.max((it.quantity || 1) - 1, 0))
        );
        li.querySelector('[data-qty-inc]').addEventListener('click', () =>
          this.change(i + 1, (it.quantity || 1) + 1)
        );
        li.querySelector('[data-remove]').addEventListener('click', () => this.change(i + 1, 0));

       
        const priceEl = li.querySelector('[data-price]');
        const cmpEl   = li.querySelector('[data-compare-price]');

        const handle = ((it.url || '').split('/products/')[1] || '').split(/[?#]/)[0];
        const isVariety = /variety/i.test(handle);

        this.setVarietyAwarePrices(it, {
          priceEl, cmpEl,
          isSub,
          isVariety,
          fallback: unitFinal || unitBase
        });

        list.appendChild(li);
      });
    }

    const subEl = document.querySelector('[data-subtotal]');
    const subCntEl = document.querySelector('[data-subtotal-count]');
    if (subEl) subEl.textContent = this.fmt(s.items_subtotal_price || 0);
    if (subCntEl) subCntEl.textContent = s.item_count || 0;

    const wordEl = document.querySelector('[data-item-word]');
    if (wordEl) wordEl.textContent = (s.item_count === 1) ? 'item' : 'items';

    const upg = document.querySelector('[data-upgrade-sub]');
    if (upg) {
      const hasNonSub = (s.items || []).some(it => !it.selling_plan_allocation);
      upg.hidden = !hasNonSub;
    }

    this.fetchRecs();

    try {
      if (window.Alpine && Alpine.store('cart_count')) {
        Alpine.store('cart_count').count = s.item_count;
      }
    } catch (e) {}

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = s.item_count;
    });
  },

  async upgradeAllToSubscription(defaultPlanId) {
    const items = this.state.items || [];
    const nonSubs = items
      .map((it, idx) => ({ it, line: idx + 1 }))
      .filter(x => !x.it.selling_plan_allocation);

    if (!nonSubs.length) return;

    const getHandle = (url) => {
      try {
        const part = (url || '').split('/products/')[1] || '';
        return part.split('?')[0].split('#')[0];
      } catch (e) { return ''; }
    };

    const pickMonthlyPlanId = (productJson) => {
      const groups = productJson?.selling_plan_groups || [];
      for (const g of groups) {
        const plans = g.selling_plans || [];
        const byInterval = plans.find(p =>
          (p?.delivery_policy?.interval === 'month' &&
           (p?.delivery_policy?.interval_count || 1) === 1)
        );
        if (byInterval) return byInterval.id;
        const byName = plans.find(p => /month/i.test(p?.name || p?.title || ''));
        if (byName) return byName.id;
        if (plans[0]?.id) return plans[0].id;
      }
      return null;
    };

    const changeToPlan = async (line, qty, planId) => {
      if (!planId) return;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty, selling_plan: planId })
      });
    };

    for (const row of nonSubs) {
      const qty = row.it.quantity || 1;
      let planIdToUse = defaultPlanId || null;

      if (!planIdToUse) {
        const handle = getHandle(row.it.url || '');
        if (handle) {
          try {
            const r = await fetch(`/products/${handle}.js`);
            if (r.ok) {
              const pj = await r.json();
              const found = pickMonthlyPlanId(pj);
              if (found) planIdToUse = found;
            }
          } catch (e) {}
        }
      }

      try { await changeToPlan(row.line, qty, planIdToUse); } catch (e) {}
    }

    await this.fetch();
    this.open();
  },

  async setVarietyAwarePrices(item, { priceEl, cmpEl, isSub, isVariety, fallback = 0 }) {
    try {
      const r = await fetch(`/variants/${item.variant_id}.js`);
      if (!r.ok) throw new Error('variant fetch fail');
      const v = await r.json();

      const priceCents   = this._toInt(v.price);            
      const compareCents = this._toInt(v.compare_at_price); 

      if (isSub) {
        if (isVariety) {
          
          priceEl.textContent = this.fmt(priceCents || fallback);
          if (compareCents && compareCents > priceCents) {
            cmpEl.textContent = this.fmt(compareCents);
            cmpEl.hidden = false;
          } else {
            cmpEl.hidden = true;
          }
        } else {
          
          const subCents = Math.round((priceCents || fallback) * 0.85);
          priceEl.textContent = this.fmt(subCents);
          if (priceCents && subCents < priceCents) {
            cmpEl.textContent = this.fmt(priceCents);
            cmpEl.hidden = false;
          } else {
            cmpEl.hidden = true;
          }
        }
        return;
      }

      // ONE-TIME
      if (isVariety) {
        const main = compareCents || priceCents || fallback;
        priceEl.textContent = this.fmt(main);
        cmpEl.hidden = true;
      } else {
        priceEl.textContent = this.fmt(priceCents || fallback);
        cmpEl.hidden = true;
      }
    } catch (e) {
      priceEl.textContent = this.fmt(fallback || 0);
      if (cmpEl) cmpEl.hidden = true;
    }
  },

  async fetchRecs() {
    const wrap = document.querySelector('[data-recs]');
    const list = document.querySelector('[data-recs-list]');
    if (!wrap || !list) return;

    if (!this.state.items?.length) {
      wrap.hidden = true;
      list.innerHTML = '';
      return;
    }

    const ids = [...new Set(this.state.items.map(it => it.product_id))];
    const key = ids.join(',');
    if (this._lastRecKey === key) return;
    this._lastRecKey = key;

    try {
      const r = await fetch(`/recommendations/products.json?product_id=${ids[0]}&limit=6`);
      const data = await r.json();
      const inCart = new Set(this.state.items.map(it => it.product_id));
      const products = (data.products || data || []).filter(p => !inCart.has(p.id)).slice(0,3);
      this.renderRecs(products);
    } catch (e) {
      this.renderRecs([]);
    }
  },

  renderRecs(products) {
    const wrap = document.querySelector('[data-recs]');
    const list = document.querySelector('[data-recs-list]');
    if (!wrap || !list) return;

    list.innerHTML = '';
    if (!products.length) { wrap.hidden = true; return; }
    wrap.hidden = false;

    products.forEach(p => {
      const v = (p.variants && p.variants[0]) || {};
      const img = (p.images && p.images[0]?.src) || p.featured_image || '';
      const size = v.title || '';
      const price = typeof v.price === 'number' ? v.price : parseInt(v.price, 10) || 0;

      const el = document.createElement('div');
      el.className = 'oasis-rec';
      el.innerHTML = `
        <img class="oasis-rec__img" src="${img}" alt="">
        <div class="oasis-rec__meta">
          <div class="oasis-rec__title">${p.title}</div>
          ${(size && size.toLowerCase() !== 'default title') ? `<div class="oasis-rec__variant">Size: ${size}</div>` : ''}
          <button class="oasis-rec__add" type="button" data-variant-id="${v.id}">ADD</button>
        </div>
        <div class="oasis-rec__price">${this.fmt(price)}</div>
      `;
      el.querySelector('.oasis-rec__add').addEventListener('click', () => {
        this.add({ id: v.id, quantity: 1 });
      });
      list.appendChild(el);
    });
  },

  bindGlobal() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); CART.open(); }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); CART.close(); }

      const upgBtn = e.target.closest('[data-upgrade-sub]');
      if (upgBtn) {
        e.preventDefault();
        const raw = upgBtn.getAttribute('data-plan-id');
        const defaultPlanId = raw && /^\d+$/.test(raw) ? parseInt(raw, 10) : null;
        CART.upgradeAllToSubscription(defaultPlanId);
      }
    });


    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (form.action && form.action.includes('/cart/add')) {
        e.preventDefault();
        await this.add(new FormData(form));
      }
    });

    
    (function () {
      const _fetch = window.fetch;
      window.fetch = async function (...args) {
        const res = await _fetch.apply(this, args);
        try {
          const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
          if (url.includes('/cart/add')) setTimeout(() => CART.fetch(), 0);
        } catch (e) { /* noop */ }
        return res;
      };
    })();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  CART.bindGlobal();
  CART.fetch();
});
